import { render, staticRenderFns } from "./OBtnToolTipHeaderComp.vue?vue&type=template&id=585c7e07&"
import script from "./OBtnToolTipHeaderComp.vue?vue&type=script&lang=js&"
export * from "./OBtnToolTipHeaderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports